import { render, staticRenderFns } from "./OTPConfirm.vue?vue&type=template&id=3263a857"
import script from "./OTPConfirm.vue?vue&type=script&lang=js"
export * from "./OTPConfirm.vue?vue&type=script&lang=js"
import style0 from "./OTPConfirm.vue?vue&type=style&index=0&id=3263a857&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports